import kilometerType from '@/constants/kilometerType';
import { i18n } from '@/locales';
const { TEN_KILOMETER, THIRTY_KILOMETER, FIFTY_KILOMETER, NINETY_NINE_KILOMETER, } = kilometerType;
const kilometerProductOptionList = [];
for (let i = 0; i <= NINETY_NINE_KILOMETER; i += 1) {
    if (i < TEN_KILOMETER
        || (i <= THIRTY_KILOMETER && i % TEN_KILOMETER === 0)
        || (i === FIFTY_KILOMETER)
        || (i === NINETY_NINE_KILOMETER)) {
        kilometerProductOptionList.push(i);
    }
}
export default kilometerProductOptionList.map((kilometer) => ({
    text: `${kilometer} ${i18n.t('common.km')}`,
    value: kilometer,
}));
